import React from "react";
import { connect } from "react-redux";
import stateClauses from "../helpers/state_clauses.json";
import { Reinstatement, SystemTable, Termination, TermLedger } from "./";

function TextSections(props) {
  const { address, coRenter, renter, term } = props;

  const currentDate = new Date();
  const mm = currentDate.getMonth() + 1;
  const dd = currentDate.getDate();
  const yyyy = currentDate.getFullYear();
  const todayFormatted = `${mm}/${dd}/${yyyy}`;

  const stateText = stateClauses[props.taxState];

  const payoffPercentage = () => {
    if (!term) {
      return;
    }

    const termString = term.term.toString();

    switch (termString) {
      case "36":
        return "55%";
        break;
      case "48":
        return "50%";
        break;
      case "60":
        return "45%";
        break;
      case "72":
        return "40%";
        break;
      default:
        return "(not available)";
        break;
    }
  };

  const startDate = new Date();

  const contractAddress = address.address_2
    ? `${address.address_1} ${address.address_2} ${address.city}, ${address.state} ${address.zip}`
    : `${address.address_1} ${address.city}, ${address.state} ${address.zip}`;

  const renterAddress = renter.address_2
    ? `${renter.address_1} ${renter.address_2} ${renter.city}, ${renter.state} ${renter.zip}`
    : `${renter.address_1} ${renter.city}, ${renter.state} ${renter.zip}`;

  let coRenterAddress = null;

  if (coRenter) {
    coRenterAddress = coRenter.address_2
      ? `${coRenter.address_1} ${coRenter.address_2} ${coRenter.city}, ${coRenter.state} ${coRenter.zip}`
      : `${coRenter.address_1} ${coRenter.city}, ${coRenter.state} ${coRenter.zip}`;
  }

  return (
    <div style={{ margin: "15px 0 30px 0" }}>
      <p>
        This agreement made and entered into on{" "}
        <strong>
          <u>{todayFormatted}</u>
        </strong>{" "}
        (a copy of which has been furnished to Renter as evidenced by Renter's
        signature as it appears below), by and between Atwood Rentals HVAC LLC.
        managed by Summit Management Group, Inc. having its principal place of
        business at: 1148 South Main St. Suite A, Milan, TN 38358, Gibson
        County, TN hereinafter referred to as "Lessor" and{" "}
        <strong>
          <u>
            {renter.first_name} {renter.last_name}
          </u>
        </strong>{" "}
        whose address is{" "}
        <strong>
          <u>{contractAddress}</u>
        </strong>
        {coRenter ? (
          <span>
            , and{" "}
            <strong>
              <u>
                {coRenter.first_name} {coRenter.last_name}
              </u>
            </strong>{" "}
            whose address is{" "}
            <strong>
              <u>{coRenterAddress}</u>
            </strong>
            , hereinafter referred to as "Renter".
          </span>
        ) : (
          ', hereinafter referred to as "Renter".'
        )}
      </p>
      <p>
        <strong>WITNESSETH:</strong>
      </p>
      <ol>
        <li>
          For and in consideration of mutual covenants and agreements
          hereinafter set forth, Lessor hereby leases to Renter and Renter
          hereby leases from Lessor the certain heating and cooling unit and
          equipment described below.
        </li>
        <li>
          The following information is hereby disclosed to the Renter pursuant
          to Tennessee Code Annotated §47-18-604 and are terms and conditions of
          this agreement.
          <ul style={{ listStyle: "upper-alpha" }}>
            <li>
              The merchandise (property) to be leased and which is the subject
              of this agreement is described as follows:
              <SystemTable systems={props.systems} />
              <TermLedger term={props.term} />
            </li>
            <li>
              The cash price of the lease merchandise on the date of this
              agreement is ${term ? term.total_hvac_system_cost : null} plus $
              {parseFloat(props.additionalCost)
                ? parseFloat(props.additionalCost).toFixed(2)
                : 0.0}{" "}
              in additional materials, totaling{" "}
              <strong>
                <u>${term ? term.cash_total : null}</u>
              </strong>{" "}
              plus applicable sales tax.
            </li>
            <li>
              Before consummation of this Agreement or delivery of the
              merchandise, whatever is later, is as follows: Renter will pay a
              contract cost reduction of:{" "}
              <strong>
                <u>${term ? term.total_purchase_reserve : null}</u>
              </strong>{" "}
              (including appropriate sales tax).{" "}
              <u>
                If contract cost reduction returns this contract is null and
                void and Lessor is not obligated to fulfill the contract.
              </u>
            </li>
            <li>
              The term of this agreement is for one (1) month from the date of
              this Agreement. This Agreement automatically renews for
              consecutive terms of one (1) month at the expiration of the prior
              term unless terminated as provided for in this Agreement. The
              rental payment is due on or before the beginning of the renewal
              term for which you wish to rent the merchandise, up to:
              <strong> Term of Ownership: </strong>
              <strong>
                <u>{term ? term.term : null} months.</u>
              </strong>
            </li>
            <li>
              Rental Payment is{" "}
              <strong>
                <u>${term ? term.monthly_pretax : null}</u>
              </strong>{" "}
              plus{" "}
              <strong>
                <u>${term ? term.monthly_tax : null}</u>
              </strong>{" "}
              tax for a Monthly Total of{" "}
              <strong>
                <u>${term ? term.total_monthly_payment : null}</u>
              </strong>
              .{" "}
              <strong>
                <u>
                  1st payment due date is 45 days after the renter(s) have
                  signed the agreed contract, then continued for each succeeding
                  month of contract term, or until paid off.
                </u>
              </strong>{" "}
              Sales tax based on city, county and state rates and may be
              modified to reflect sales tax rate changes enacted by applicable
              governmental taxing authorities. If Renter makes monthly payments
              on time for a total cost of{" "}
              <strong>
                <u>${term ? term.full_term_payoff : null}</u>
              </strong>{" "}
              (monthly rent (x) the monthly term) in addition to the contract
              cost reduction of:{" "}
              <strong>
                <u>${term ? `${term.cost_reduction_after_tax} ` : null}</u>
              </strong>{" "}
              (pretax) and meets the requirements of the agreement, renter will
              acquire ownership of the rented merchandise. At any time after
              Renter has made the first rental payment, renter may purchase
              rented property for:{" "}
              <strong>
                <u>{payoffPercentage()}</u>
              </strong>{" "}
              of the remaining contract balance at that time. (Exclusive of
              taxes, reinstatement and other charges).
            </li>
            <li>
              Renter will not have legal title or an equitable interest in the
              property until Renter has made the number of payments and the
              total of payments necessary to acquire ownership. The total of
              payments necessary to acquire ownership includes all costs
              included in the purchase reserve but does not include other
              charges Renter may incur.
            </li>
            <li>
              The total number of payments does not include other charges such
              as late payment fees, returned check fees, default, pick-up,
              reinstatement, trip fees, and/or attorney’s fees**. These charges
              are explained in each section provided and will be reasonably
              related to the service performed. Renter acquires no ownership
              rights in the merchandise until Renter complies fully with the
              ownership terms of this Agreement and makes all payments indicated
              herein. **
              <u>
                In the event the Lessors incur costs or expenses of enforcing
                the terms of this Agreement because of Renter’s breach, Lessor
                shall be entitled to recover from the Renter all the costs and
                expenses by reason thereof including but not limited to
                reasonable attorney fees, court costs and other related
                expenses.
              </u>
            </li>
            <li>
              Renter is responsible for the fair market value of the property if
              lost, stolen, damaged or destroyed.
            </li>
            <li>
              Renter must maintain the merchandise in good working order and
              condition in accordance with the manufacturer’s specifications and
              recommendations as long as Renter rents it. If any part of a
              manufacturer’s express warranty remains on the merchandise at the
              time Renter acquires ownership of the merchandise, it will be
              transferred to Renter, if allowed by the terms of the
              manufacturer’s warranty. At the time of the execution of this
              agreement, the Renter will understand that a warranty in the
              amount of $499 is included in the amount of the cash price of the
              unit. The Warranty is mandatory and covers any cost of repair due
              to failure of equipment excluding freon.
            </li>
            <li>
              Renter shall not permit the leased property to be altered by the
              addition of equipment and accessories or the placing of signs
              thereon and shall not permit the lease property to be tied to or
              otherwise affixed to any real-estate in such a manner that the
              same cannot be removed without damage to the leased property.{" "}
              <strong>
                Renter shall not obstruct access to property so as to prevent
                removal in the event of termination.
              </strong>
            </li>
            <li>
              Renter may terminate this Agreement without penalty by (i)
              providing notice of termination, (ii) voluntary surrendering or
              returning the merchandise in good and working condition at the end
              of any rental term (normal wear and tear expected), and (iii)
              paying all rental payments and fees due as of that date. Lessor
              may terminate this Agreement for a default in payment or breach of
              any other material term of this Agreement. If a termination
              occurs, Lessor shall be entitled to all rental payment up to the
              date of the termination and, if Renter fails to surrender the
              merchandise to lessor, the expenses of repossessing the
              merchandise plus compensation, including trip fees not to exceed
              $350.00 at the monthly rental amount found in the Agreement, for
              the time period that the merchandise is wrongfully retained by
              renter.
            </li>
          </ul>
        </li>
        <Termination state={props.taxState} />
        <Reinstatement state={props.taxState} />
        <li>
          The rented property shall be kept at the address shown herein. It may
          not be moved from that address without Lessor’s written consent.{" "}
          <u>
            The rented property may only be moved by carriers authorized in
            writing by Lessor.
          </u>
        </li>
        <li>
          Renter may not assign any of Renter’s right under this Contract to any
          third party without the written consent of Lessor.
        </li>
        <li>
          Lessor shall have the right to examine and inspect the rented property
          at all reasonable times. Lessor shall have the right to remove the
          property in the event of non-payment and/or default under this
          contract.
        </li>
        <li>
          Notwithstanding anything contained in this agreement to the contrary,
          the Lessor shall be liable to the Renter or to any other person, firm,
          or corporation by reason of the loss of, damage to or destruction of
          any structure attached to the leased property from time to time,
          unless such loss of, damage or destruction is due to the negligence of
          the Lessor, its agent, servant or employees. In the event and whether
          or not such loss, damage or destruction of such property kept in the
          leased premises is due to the negligence of the Lessor, its agents, or
          its employees, or otherwise, the liability of the lessor shall not
          exceed the value of the merchandise in question. In this regard, the
          Renter warrants and guarantees to the Lessor that no property in
          excess of the said limit of liability shall be placed on or attached
          to the leased property other than at the sole peril of the Renter.
        </li>
        <li>
          Notice is hereby given to any holder of this instrument or any
          interest therein that to the extent this instrument may be deemed to
          be a consumer credit contract, the rights of said holder, if any, are
          subject to all claims and defenses which the Renter could assert
          against the Lessor of goods and service obtained pursuant thereto, but
          with recovery by the Renter being limited to the amount paid by Renter
          hereunder.
        </li>
        <li>
          Renter agrees to promptly remove all of Renter’s property attached to
          the lease property at the termination of this agreement, whether such
          termination is caused by Renter’s default, or by lapse of time, and
          lessor may elect that any personal property not removed at such
          termination by Renter is deemed abandoned by Renter and same shall
          become the property of the Lessor without any payment or offset
          therefore. If lessor shall not so elect, the lessor may remove such
          property from the leased premises and store same at Renter’s risk and
          expense.
        </li>
        <li>
          This contract constitutes written permission for lessor to enter
          Renter’s property, open gates, move obstacles or take any reasonable
          means necessary to recover the leased property in the event of default
          by Renter. By signing this agreement, the Renter hereby authorizes any
          person having an interest in the real property to which the property
          leased hereunder is affixed including but not limited to, landlords,
          owners and/or co-renters, the right to enter said property for the
          purpose of assisting Lessor in recovering the lease property. This
          permission may only be terminated by giving written notice to Lessor.
        </li>
        <li>
          In the event the lessor shall incur costs and expenses in enforcing
          the terms of this agreement because of the breach thereof by the
          Renter or by the agents, servants or employees of the Renter, the
          lessor shall recover from and the Renter shall pay to Lessor, all of
          the costs and expenses by reason thereof, including but not limited to
          Lessor’s reasonable attorney’s fees and court costs. In the event
          Renter defaults in complying with the terms of this Lease and Lessor
          proceeds to recover the rented property, the Renter pays the amount in
          arrears after lessor has incurred expenses to recover the same, the
          Renter shall pay lessor in addition to the payments in arrears the sum
          of the expenses incurred.
        </li>
        <li>
          Should Renter file <strong>Bankruptcy</strong>, the renter’s attorney
          must be advised that this lease/rental agreement meets the
          requirements of the Consumer Rental-Purchase Agreement Act. Therefore,
          renter will be required to either assume or reject this lease. The
          true and proper placement of the renter’s debit to us is as an
          “executory contract/unexpired lease”. The leased/rented property is
          not considered to be a personal property, secured property or secured
          asset of Renter. Any listing of such could compel Lessor to file for
          automatic stay in order to recover the leased property. All claims
          arising out of/or relating to this lease must be brought in an
          individual capacity and not as Plaintiff or class member in any
          purported class or represented pleading.
        </li>
        <li>
          If a dispute arises under this agreement, the parties will initially
          attempt to resolve the dispute through friendly consultation. If the
          dispute is not resolved within a reasonable period, either party may
          bring suit against the other in a civil court having authority to hear
          replevin actions with the limitations that matters) with potential
          damages over $20,000.00 must be submitted to binding{" "}
          <strong>Arbitration</strong> governed by the Federal Arbitration Act.
        </li>
        <li>
          In the event of a returned check, a fee will be charged that meets
          state law of where the renter resides.
        </li>
        <li>
          The Renter agrees that this lease is not valid until received by
          Lessor in its home office and that the laws of the State of Tennessee,
          the home state of the Lessor, shall govern this contract in all
          respects and Renter further agrees to submit to the jurisdiction of
          the Courts of Tennessee, including but not necessarily limited to the
          courts of Gibson County, Tennessee, the site of the home office of
          Lessor.
        </li>
        <li>
          This agreement sets forth the parties’ entire agreement and may not be
          changed except in paper writing signed by both parties in Milan,
          Tennessee, Gibson County, State of Tennessee and accepted.
        </li>
        <li>
          By executing this agreement, Renter agrees that:
          <ul style={{ listStyle: "upper-alpha" }}>
            <li>Renter has read and understands this agreement.</li>
            <li>
              Renter has been given a signed and legible copy with all blanks
              filled in.
            </li>
            <li>
              Renter will receive the rented property in good condition and will
              not accept the property otherwise.
            </li>
            <li>Renter agrees that they can be contacted via text message.</li>
            <li>
              Renter hereby acknowledges the Lessor maintains the right to
              assign this contract to a third party and further agrees to remit
              rental payments to such party if so assigned.
            </li>
          </ul>
        </li>
        <li>
          In the event of default, Renter will be liable for a late charge equal
          to {stateText ? stateText.late_fee : "$0.00"} plus any applicable
          sales tax, and all costs of collection including the repossession
          fees, collection agency fees, reasonable attorneys’ fees and court
          costs. If renter chooses to pay more frequently than on a monthly
          schedule Renter may pay more. A{" "}
          {stateText ? stateText.grace_period : "0"} grace period is extended to
          the Renter on rental payment due date.
        </li>
        <li>
          This agreement contains additional and other important terms on the
          following pages, all of which are incorporated herein as if stated
          verbatim and made a part of this agreement. By signing below, Renter
          acknowledges and agrees to all such terms and acknowledges the receipt
          of a copy of this Agreement.
        </li>
      </ol>
      <p>
        <strong>
          IN WITNESS WHEREOF, the parties have hereunto affixed their signatures
          of the day and date first written above.
        </strong>
      </p>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    address: state.address,
    additionalCost: state.term.additionalCost,
    coRenter: state.coRenter,
    renter: state.renter,
    systems: state.systems,
    taxState: state.address.state,
    term: state.term.selected,
  };
}

export default connect(mapStateToProps)(TextSections);
